import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA4_ID = "G-H8SJV5FF89";

/** Google Ads — conversion action "Submit lead form" */
const GOOGLE_ADS_SUBMIT_LEAD_SEND_TO = "AW-18075954854/R9vOCKuPhJocEKbdpKtD";

export function trackGoogleAdsSubmitLeadFormConversion() {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", { send_to: GOOGLE_ADS_SUBMIT_LEAD_SEND_TO });
}

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    const pagePath = location.pathname + (location.search || "");
    window.gtag("config", GA4_ID, { page_path: pagePath });
  }, [location]);
};

export default usePageTracking;
